<template>
  <div class="chat-controls">
    <!-- Search Bar -->
    <div v-if="showSearch" class="search-container">
      <div class="search-input-wrapper">
        <v-icon size="18" color="#9E9E9E" class="search-icon">mdi-magnify</v-icon>
        <input
          type="text"
          v-model="searchQuery"
          @input="handleSearch"
          class="search-input"
          dir="rtl"
          placeholder="جستجو در گفتگو..."
        />
        <button v-if="searchQuery" @click="clearSearch" class="search-clear-btn">
          <v-icon size="16" color="#9E9E9E">mdi-close</v-icon>
        </button>
      </div>
      <div v-if="searchResults.length > 0" class="search-results">
        <div class="search-results-header">
          <span>{{ searchResults.length }} نتیجه یافت شد</span>
          <button @click="clearSearch" class="search-close-btn">بستن</button>
        </div>
      </div>
    </div>

    <!-- Controls Menu -->
<!--    <div class="controls-menu" v-if="showMenu">-->
<!--      <v-menu offset-y left>-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <button class="control-btn" v-bind="attrs" v-on="on">-->
<!--            <v-icon size="20" color="#6B7FD7">mdi-dots-vertical</v-icon>-->
<!--          </button>-->
<!--        </template>-->
<!--        <v-list dense class="controls-list" dir="rtl">-->
<!--          <v-list-item @click="toggleSearch">-->
<!--            <v-list-item-icon>-->
<!--              <v-icon size="20">mdi-magnify</v-icon>-->
<!--            </v-list-item-icon>-->
<!--            <v-list-item-content>-->
<!--              <v-list-item-title>جستجو در گفتگو</v-list-item-title>-->
<!--            </v-list-item-content>-->
<!--          </v-list-item>-->
<!--          <v-list-item @click="downloadTranscript">-->
<!--            <v-list-item-icon>-->
<!--              <v-icon size="20">mdi-download</v-icon>-->
<!--            </v-list-item-icon>-->
<!--            <v-list-item-content>-->
<!--              <v-list-item-title>دانلود گفتگو</v-list-item-title>-->
<!--            </v-list-item-content>-->
<!--          </v-list-item>-->
<!--          <v-divider></v-divider>-->
<!--          <v-list-item @click="confirmClearChat" class="danger-item">-->
<!--            <v-list-item-icon>-->
<!--              <v-icon size="20" color="#F44336">mdi-delete-outline</v-icon>-->
<!--            </v-list-item-icon>-->
<!--            <v-list-item-content>-->
<!--              <v-list-item-title class="danger-text">پاک کردن تاریخچه</v-list-item-title>-->
<!--            </v-list-item-content>-->
<!--          </v-list-item>-->
<!--        </v-list>-->
<!--      </v-menu>-->
<!--    </div>-->

    <!-- Confirmation Dialog -->
    <v-dialog v-model="showClearConfirm" max-width="400" persistent>
      <v-card dir="rtl">
        <v-card-title class="dialog-title">
          <v-icon color="#F44336" size="24" class="mr-2">mdi-alert-circle</v-icon>
          پاک کردن تاریخچه گفتگو
        </v-card-title>
        <v-card-text class="dialog-content">
          آیا مطمئن هستید که می‌خواهید تمام تاریخچه گفتگو را پاک کنید؟ این عمل قابل بازگشت نیست.
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="showClearConfirm = false" class="cancel-btn">
            انصراف
          </v-btn>
          <v-btn color="error" @click="clearChat" class="confirm-btn">
            پاک کردن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ChatControls',
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    showMenu: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showSearch: false,
      searchQuery: '',
      searchResults: [],
      showClearConfirm: false
    }
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch;
      if (!this.showSearch) {
        this.clearSearch();
      }
    },
    handleSearch() {
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        this.searchResults = [];
        this.$emit('search', []);
        return;
      }

      const query = this.searchQuery.toLowerCase().trim();
      const results = this.messages.filter(msg => {
        const content = (msg.contents || msg.text || '').toLowerCase();
        return content.includes(query);
      });

      this.searchResults = results;
      this.$emit('search', results);
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchResults = [];
      this.$emit('search', []);
    },
    confirmClearChat() {
      this.showClearConfirm = true;
    },
    clearChat() {
      this.showClearConfirm = false;
      this.$emit('clear-chat');
    },
    downloadTranscript() {
      this.$emit('download-transcript');
    }
  },
  watch: {
    showSearch(newVal) {
      if (!newVal) {
        this.clearSearch();
      }
    }
  }
}
</script>

<style scoped>
.chat-controls {
  position: relative;
}

.search-container {
  background: #FFFFFF;
  border-bottom: 1px solid #E0E0E0;
  padding: 12px 16px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 100px;
  }
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  background: #FAFBFC;
  border: 1.5px solid #E0E0E0;
  border-radius: 12px;
  padding: 8px 12px;
  gap: 8px;
  transition: all 0.2s ease;
  direction: rtl;
}

.search-input-wrapper:focus-within {
  border-color: #6B7FD7;
  background: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(107, 127, 215, 0.1);
}

.search-icon {
  flex-shrink: 0;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #424242;
  direction: rtl;
  text-align: right;
}

.search-input::placeholder {
  color: #9E9E9E;
}

.search-clear-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
}

.search-clear-btn:hover {
  background: #F5F5F5;
}

.search-results {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #E0E0E0;
}

.search-results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #757575;
  direction: rtl;
}

.search-close-btn {
  background: transparent;
  border: none;
  color: #6B7FD7;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.search-close-btn:hover {
  background: #F0F4FF;
}

.controls-menu {
  display: flex;
  align-items: center;
}

.control-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
}

.control-btn:hover {
  background: rgba(107, 127, 215, 0.1);
}

.controls-list {
  min-width: 200px;
}

.danger-item {
  color: #F44336;
}

.danger-text {
  color: #F44336 !important;
}

.dialog-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #424242;
  padding: 20px 20px 12px 20px;
}

.dialog-content {
  padding: 12px 20px;
  color: #757575;
  font-size: 14px;
  line-height: 1.6;
}

.dialog-actions {
  padding: 12px 20px 20px 20px;
}

.cancel-btn {
  color: #757575;
}

.confirm-btn {
  color: #FFFFFF;
}

/* RTL Support */
[dir="rtl"] .controls-list {
  text-align: right;
}

/* Mobile */
@media (max-width: 600px) {
  .search-container {
    padding: 10px 12px;
  }
  
  .search-input {
    font-size: 13px;
  }
}
</style>


